<div class="bulk-action-bar" [class.visible]="visible()" [attr.aria-hidden]="!visible()" role="region" aria-label="Bulk actions">
  <div class="summary">
    <p-button class="clear" icon="pi pi-times" [rounded]="true" [text]="true" [plain]="true"
      pTooltip="Clear selection" tooltipPosition="top" ariaLabel="Clear selection"
      (onClick)="onClear()"></p-button>
    <span class="count"><span class="number">{{ count() }}</span> selected</span>
    @if (breakdown()) {
      <span class="breakdown">{{ breakdown() }}</span>
    }
  </div>

  <div class="actions">
    <span class="action-wrap" [pTooltip]="message().tooltip" tooltipPosition="top">
      <p-button label="Message" [rounded]="true" [disabled]="message().disabled" (onClick)="onAction('message')"></p-button>
    </span>
    <span class="action-wrap" [pTooltip]="approve().tooltip" tooltipPosition="top">
      <p-button [label]="approveLabel()" [rounded]="true" [outlined]="true" [disabled]="approve().disabled" (onClick)="onAction('approve')"></p-button>
    </span>

    <span class="divider" aria-hidden="true"></span>

    <span class="action-wrap" [pTooltip]="deny().tooltip" tooltipPosition="top">
      <p-button label="Deny" [rounded]="true" severity="danger" [disabled]="deny().disabled" (onClick)="onAction('deny')"></p-button>
    </span>
    <span class="action-wrap" [pTooltip]="fire().tooltip" tooltipPosition="top">
      <p-button label="Fire" [rounded]="true" severity="danger" [disabled]="fire().disabled" (onClick)="onAction('fire')"></p-button>
    </span>
  </div>
</div>
